import { AppShell, Burger, Group, Image } from '@mantine/core';
import { useDisclosure, useMediaQuery } from '@mantine/hooks';
import V2Navbar from './V2Navbar';

export default function AviaryV2Shell({ children }) {
  const [opened, { toggle, close }] = useDisclosure();
  const isDesktop = useMediaQuery('(min-width: 768px)', true);

  return (
    <AppShell
      header={{ height: 56, collapsed: !!isDesktop }}
      navbar={{ width: 80, breakpoint: 'sm', collapsed: { mobile: !opened } }}
      padding={0}
    >
      <AppShell.Header>
        <Group h="100%" px="md" justify="space-between" bg="aviary.8">
          <Burger opened={opened} onClick={toggle} size="sm" color="#EBE2D3" />
          <Image src="/logo_small.png" h={36} fit="contain" />
        </Group>
      </AppShell.Header>

      <AppShell.Navbar p={0} style={{ overflow: 'hidden' }}>
        <V2Navbar onNavClick={close} />
      </AppShell.Navbar>

      <AppShell.Main>
        <div
          style={{
            '--aviary-canvas': '#F4F1EC',
            '--aviary-surface': '#FFFFFF',
            '--aviary-ink': '#2B2A27',
            '--aviary-muted': '#7A756C',
            '--aviary-disabled': '#D8D2C6',
            background: 'var(--aviary-canvas)',
            color: 'var(--aviary-ink)',
            minHeight: '100%',
          }}
        >
          {children}
        </div>
      </AppShell.Main>
    </AppShell>
  );
}
